import React, { useCallback } from 'react';
import isNil from 'lodash-es/isNil';

import { OptionalCarRegistrationNumberControlProps } from './OptionalCarRegistrationNumberControl.interfaces';
import { isValidCarRegistrationNumber } from 'app/validators/validateCarRegistrationNumber';
import { CarRegistrationNumberControl } from 'app/components/Controls';
import { setMessageVisibility } from 'app/services/businessFunctionHelpers';
import { FormsEnum, MessagesEnum } from 'app/shared/enums';

const OptionalCarRegistrationNumberControl = (
  props: OptionalCarRegistrationNumberControlProps
) => {
  const {
    input,
    input: { value },
    onControlBlur,
    onValueChange,
  } = props;

  const handleChange = useCallback(
    (value: string) => {
      input.onChange(value ? value : null);

      if (onValueChange) {
        onValueChange(value, false, false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onChange, onValueChange]
  );

  const handleBlur = useCallback(() => {
    const isValid = isValidCarRegistrationNumber(value);
    const shouldPatch = isValid || !value;
    const isEmpty = value === '' || isNil(value);
    const isAnonymized = (value || '').includes('***');
    const showObfuscatedMessage = !isAnonymized && !isEmpty && !isValid;

    setMessageVisibility({
      key: MessagesEnum.CarRegistrationNumberError,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });

    setMessageVisibility({
      key: MessagesEnum.CarRegistrationNumberInvalid,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });

    if (onControlBlur) {
      onControlBlur(shouldPatch, true, true);
    }
  }, [value, onControlBlur]);

  return (
    <CarRegistrationNumberControl
      {...props}
      onControlBlur={handleBlur}
      onValueChange={handleChange}
    />
  );
};

export default OptionalCarRegistrationNumberControl;
